import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useTranslation } from 'react-i18next';
import LobbySmallImg from '../../assets/images/lobby.png';
import LobbyMediumImg from '../../assets/images/lobby-2.png'
import LobbyLargeImg from '../../assets/images/lobby-3.png'
import ContactModal from "../../components/ContactModal/ContactModal";

const Lobby = () => {
  const { t } = useTranslation()

    const [contactModal, setContactModal] = useState(false);
    const toggleContactModal = () => setContactModal(!contactModal);

  return (
    <div>
      <Header />

        <div className="position-relative">
          <img
            src={LobbyMediumImg}
            srcSet={`${LobbyLargeImg} 1920w, ${LobbyMediumImg} 1500w, ${LobbySmallImg} 500w`}
            className="w-100"
          />

          <p onClick={toggleContactModal}
            className="position-absolute font-weight-bold"
            style={{ fontSize: '.7vw', top: '58%', left: '30%', cursor: 'pointer' }}
          >{t('lobbyOrganizedBy')}</p>
          <p onClick={toggleContactModal}
            className="position-absolute font-weight-bold"
            style={{ fontSize: '.7vw', top: '62.5%', left: '30%', cursor: 'pointer' }}
          >{t('lobbySupportedBy')}</p>
          <p onClick={toggleContactModal}
            className="position-absolute font-weight-bold"
            style={{ fontSize: '1.2vw', top: '66%', left: '29.5%', cursor: 'pointer' }}
          >{t('lobbyHelpDesk')}</p>

            <ContactModal toggleContactModal={toggleContactModal} isOpen={contactModal} />

          {/* Video */}
          <div className="position-absolute" style={{width: '20%', left: '44%', top: '17%', zIndex: -55}}>
            <video controls autoPlay loop className="w-100" src={"https://businessexpoapi-stg.greenkosovo.com/Videos\\Companies\\77777777777.mp4"} />
          </div>
          
          {/* Green Pavilion button */}
          <Link to="/booths">
            <div 
              className="position-absolute"
              style={{
                cursor: 'pointer',
                width: '20%',
                top: '5%',
                left: '10%'
              }}>

              <img
                className="w-100"
                src={require('../../assets/images/lobby-btn1.png')}
              />
              <p
                className="position-absolute font-weight-bold text-uppercase app-text-primary"
                style={{top: '52%', left: '24%', fontSize: '1.3vw'}}
              >{t('lobbyPavilionBtn')}</p>
            </div>
          </Link>

          {/* Green Forums Button */}
          <Link to="/greenforums">
            <div 
              className="position-absolute"
              style={{
                cursor: 'pointer',
                width: '20%',
                top: '5%',
                right: '8%'
              }}>

              <img
                style={{transform: `scaleX(-1)`}}
                className="w-100"
                src={require('../../assets/images/lobby-btn1.png')}
              />
              <p
                className="position-absolute font-weight-bold text-uppercase app-text-primary"
                style={{top: '52%', left: '10%', fontSize: '1.3vw'}}
              >{t('lobbyForumBtn')}</p>
            </div>
          </Link>

          {/* Product Presentation Button */}
          {/*<Link to="/productpresentation">*/}
          {/*  <div */}
          {/*    className="position-absolute"*/}
          {/*    style={{*/}
          {/*      cursor: 'pointer',*/}
          {/*      width: '12%',*/}
          {/*      top: '22%',*/}
          {/*      right: '20%'*/}
          {/*    }}>*/}

          {/*    <img*/}
          {/*      className="w-100"*/}
          {/*      src={require('../../assets/images/lobby-btn2.png')}*/}
          {/*    />*/}
          {/*    <p*/}
          {/*      className="position-absolute font-weight-bold text-uppercase text-center app-text-primary"*/}
          {/*      style={{top: '34%', right: '25%', fontSize: '1vw'}}*/}
          {/*    >{t('lobbyProductPresentationBtn')}</p>*/}
          {/*  </div>*/}
          {/*</Link>*/}
        </div>
      <Footer />
    </div>
  );
}

export default Lobby;